import { WebhooksConfigModel } from '@/models/webhooksConfig.model'
import { api } from '@/services/api'

export type FindWebhookConfigByCompanyResponse = {
  config: WebhooksConfigModel
}

export async function findWebhookConfigByCompany(companyId: string) {
  const response = await api.get<FindWebhookConfigByCompanyResponse>(`/webhooks/${companyId}`)
  return response.data
}
